// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import { IBodyUpdate, IQueryParamBase } from '~/utils/interface/common';
import {
  CREATE_COUPON,
  DELETE_COUPON,
  GET_DETAIL_COUPON,
  GET_LIST_COUPON,
  UPDATE_COUPON,
} from '~/utils/constants/actionType';
import couponApi from '~/apis/coupon';
import { IFormCoupon, IFormUpdateCoupon } from '~/utils/interface/coupon';

export const getListCoupon = createAsyncThunk(GET_LIST_COUPON, async (params: IQueryParamBase, { rejectWithValue }) => {
  try {
    const resp = await couponApi.getListCoupon(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getDetailCoupon = createAsyncThunk(GET_DETAIL_COUPON, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await couponApi.getDetailCoupon(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const createCoupon = createAsyncThunk(CREATE_COUPON, async (body: IFormCoupon, { rejectWithValue }) => {
  try {
    const resp = await couponApi.createCoupon(body);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateCoupon = createAsyncThunk(
  UPDATE_COUPON,
  async (params: IBodyUpdate<IFormUpdateCoupon>, { rejectWithValue }) => {
    try {
      const resp = await couponApi.updateCoupon(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteCoupon = createAsyncThunk(DELETE_COUPON, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await couponApi.deleteCoupon(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});
